import type { Logger } from '@devhacker/shared/libs/logger';
import type { ISearchApi } from '~/types/api/search';
import { API_URL, API_URL_PREFIX, API_TIMEOUT } from '~/constants/config';
import { createAxiosLikeFetch } from '@devhacker/shared/libs/fetch/createAxiosLikeFetch';
import { createLoggerInterceptors } from '@devhacker/shared/libs/logger';

type Params = {
  $logger: Logger;
};

export default ({ $logger }: Params): ISearchApi => {
  const searchFetch = createAxiosLikeFetch({
    baseURL: `${API_URL}${API_URL_PREFIX}`,
    timeout: API_TIMEOUT,
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    ...createLoggerInterceptors($logger, 'search'),
  });

  return {
    search(payload) {
      const body = { 'slug-list': payload };
      return searchFetch('/aggregate-search', { method: 'POST', body });
    },
  };
};
